import * as React from "react";
export default function ImageAva(props) {
    return (
        <svg
        {...props}
        width={110}
        height={140}
        viewBox="0 0 64 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M56.4 59.063C56.4 73.923 44.24 86 29.2 86S2 73.923 2 59.063c0-14.86 12.16-26.937 27.2-26.937s27.2 12.077 27.2 26.937z"
          fill="#56CCF2"
          stroke="#5675D3"
          strokeWidth={4}
        />
        <g clipPath="url(#prefix__clip0)">
          <path
            d="M20.566 75.557l-.674.47c-.058.158.442.39.442.39.203-.157.296-.575.232-.86z"
            fill="#208442"
          />
          <path
            d="M24.862 78.967c0 .046-.203.238-.529.494-1.184.918-4.11 2.76-5.427 2.225-.36-.907-.215-2.365.162-3.05.32-.581.772-1.807 1.184-2.748.076-.174.146-.342.221-.488.046-.104.099-.209.14-.302.493-1.173.568-2.23.771-3.77.233-1.673 1.637-3.009 2.944-3.398 0 0 .273 5.722.423 8.928.064 1.203.105 2.05.11 2.109z"
            fill="url(#prefix__paint0_radial)"
          />
          <path
            d="M24.862 78.967c0 .046-.203.238-.529.494a2.676 2.676 0 01-.876-.349c-.685-1.522-2.59-1.65-3.425-1.597.458-.43 1.37-.814 1.98-.814-.413-.342-1.098-.65-1.754-.813.076-.174.145-.342.22-.488.047-.104.1-.209.14-.302.697-.464 1.504-.993 1.544-1.005.058 0 1.428 1.482 2.601 2.765.052 1.203.093 2.051.099 2.109z"
            fill="url(#prefix__paint1_linear)"
          />
          <path
            d="M20.171 77.52c.372-.238.801-.389 1.248-.453a3.51 3.51 0 011.347.07c.441.116.853.32 1.213.587.36.267.662.61.877 1a4.933 4.933 0 00-.999-.82c-.36-.22-.754-.39-1.16-.488a4.136 4.136 0 00-1.255-.128 4.81 4.81 0 00-1.27.233z"
            fill="#B98B2D"
          />
          <path
            d="M41.76 74.854s1.12 1.174 1.144 1.755c-.76.482-1.852.377-1.927.406.023-.819.784-2.16.784-2.16z"
            fill="url(#prefix__paint2_radial)"
          />
          <path
            d="M42.22 75.394a14.68 14.68 0 01-.18 1.215c-.28 1.394-.97 2.219-1.075 4.159-.023.523-.081.999-.174 1.411-.099.21-.244.424-.43.634-.476.534-1.23 1.068-2.165 1.527l-.04.018c-.744.366-1.609.685-2.537.923-.593.157-1.22.28-1.858.366-3.42.436-8.383.122-9.178-1.51-.313-.76-.517-3.869-.766-5.838v-.012c-.03-.25-.058-.5-.093-.732-.087-.72-.151-1.33-.198-1.707a41.452 41.452 0 01-.127-1.929c-.093-2.312-.03-5.617.934-5.989 1.324-.511 6.189-2.022 8.72-1.98 3.088.046 6.548 1.312 8.22 2.026 1.399.587 1.242 4.95.946 7.418z"
            fill="url(#prefix__paint3_radial)"
          />
          <path
            d="M42.22 75.395a14.65 14.65 0 01-.18 1.214c-.28 1.394-.97 2.219-1.075 4.159-.406-.72-.313 1.47-.673 1.917-.395.482-1.922.738-1.597.04.325-.697.238-3.009-.04-2.817-.279.192-1.266.877-3.181 1.72-1.916.853-3.344.784-4.546.726-1.202-.058-3.152-.285-3.802.273-.65.552-.233 1.388.725 2.666.523.697 1.08.035.952-.366-.139-.407-.418-1.597-.15-1.324.267.267.597.685 1.422 1.11.83.417 5.16.069 5.782-.407.627-.471 1.254-2.295 1.393-1.848.133.436.302 1.604.934 1.174.633-.436 1.545-1.83 2.16-2.725.197.511-.029 1.731-.012 1.877 0 .011.012.023.03.034-.477.535-1.231 1.07-2.166 1.528l-.04.018c-.906.325-1.817.656-2.537.923-.593.157-1.22.28-1.858.366-3.42.436-8.383.122-9.178-1.51-.313-.761-.517-3.869-.766-5.838v-.012c-.03-.25-.058-.5-.093-.732-.087-.72-.151-1.33-.198-1.708a41.449 41.449 0 01-.127-1.928c2.908-.343 14.89-1.79 14.89-1.79s2.49 2.04 3.93 3.26z"
            fill="url(#prefix__paint4_linear)"
          />
          <path
            d="M25.512 82.813c.128.261.261.517.406.755.145.244.302.476.47.697.169.226.343.441.534.65.192.21.39.413.604.616a3.042 3.042 0 01-.749-.465 4.01 4.01 0 01-.61-.644 3.89 3.89 0 01-.435-.773 3.352 3.352 0 01-.22-.836zM40.338 80.896c.006.244-.017.482-.064.714-.04.238-.104.47-.18.697-.08.227-.18.447-.29.657-.11.209-.25.412-.4.598.07-.232.145-.453.22-.674.087-.244.157-.453.227-.662l.238-.662c.08-.221.156-.442.25-.668zM37.11 82.656a2.312 2.312 0 01-.215.871 2.361 2.361 0 01-.534.72c.041-.145.088-.29.134-.424.053-.14.105-.273.163-.4.064-.128.133-.256.203-.384.081-.133.163-.261.25-.383zM28.728 83.893c.145.198.232.314.313.412.105.134.215.256.325.378.11.122.227.244.349.36.122.116.25.233.383.349a1.604 1.604 0 01-.5-.198 1.963 1.963 0 01-.417-.342 1.958 1.958 0 01-.302-.448 1.41 1.41 0 01-.151-.51zM25.193 80.71a2.797 2.797 0 01-.639-.668c-.18-.25-.33-.523-.453-.808a5.365 5.365 0 01-.278-.883c-.006-.017-.006-.034-.012-.052v-.012c-.03-.25-.058-.5-.093-.732.105.25.198.5.285.744.104.285.214.57.33.842.117.273.238.546.384.808.139.255.296.511.476.76zM40.774 76.609c.011.308-.018.61-.076.912-.058.302-.14.598-.25.883-.116.284-.25.563-.412.825a4.007 4.007 0 01-.563.72c.163-.343.273-.587.383-.82.122-.272.238-.545.343-.824.11-.273.215-.552.308-.837l.267-.86z"
            fill="#B98B2D"
          />
          <path
            d="M41.273 85.183c-.325.279-.813.546-1.428.808C37.047 87.147 31.7 88 28.032 88c-1.22-.006-2.253-.1-2.95-.303a43.41 43.41 0 01-.505-3.56c.813.185 1.701.29 2.636.337 4.389.22 9.747-.9 12.446-1.836.465-.157.848-.32 1.132-.46.186.89.186 1.662.482 3.004z"
            fill="url(#prefix__paint5_radial)"
          />
          <path
            d="M26.029 84.37c.162 1.155.394 2.509.632 3.578-.627-.047-1.16-.134-1.579-.256a46.926 46.926 0 01-.51-3.56c.464.104.951.18 1.457.237z"
            fill="url(#prefix__paint6_radial)"
          />
          <path
            d="M41.273 85.177c-.325.279-.807.546-1.422.801-.39.157-.83.32-1.3.465.017-.93-.129-2.277-.268-3.386.511-.146.981-.29 1.382-.43.464-.157.847-.32 1.132-.46.18.907.186 1.674.476 3.01z"
            fill="url(#prefix__paint7_radial)"
          />
          <path
            d="M42.039 72.96c-.099.291-.192.558-.267.802-.534 1.58-.79 2.382-.987 3.497-.232 1.29-.418 1.9-.76 3.311-.343 1.406-1.295 2.777-2.473 3.503a5.198 5.198 0 01-.987-.128c-2.839-.65-3.68-3.49-2.52-4.897.407-1.11.529-1.713 1.057-2.3a.413.413 0 01.046-.058c.575-.61.68-1.063.645-2.016 0-.081-.006-.18.005-.302.041-1.382.68-5.35 5.469-6.395 1.265.795 1.498 2.852.772 4.984z"
            fill="url(#prefix__paint8_radial)"
          />
          <path
            d="M33.616 79.716c2.13.686 3.675 2.074 3.651 1.33-.023-.743-1.486-2.474-2.775-2.567 1.103-.209 2.508.267 3.49 1.121-.825-1.272-1.777-2.283-3.757-1.353-1.068 1.185-.61 1.47-.61 1.47z"
            fill="url(#prefix__paint9_linear)"
          />
          <path
            d="M41.772 73.768c-.534 1.58-.79 2.382-.987 3.497-.232 1.29-.418 1.9-.76 3.311-.343 1.406-1.295 2.777-2.473 3.503a5.199 5.199 0 01-.987-.128 6.596 6.596 0 011.085-1.609c.633-.58 1.016-1.475 1.243-2.265.232-.785.18-2.156-.023-2.591-.204-.424-.204-.965-.656-.965-.418 0-1.87-.058-3.106.227a.413.413 0 01.046-.058c.575-.61.68-1.063.645-2.016 0-.081-.006-.18.005-.302.947-.255 2.508-.65 2.584-.685.075-.041 2.17.029 3.384.081z"
            fill="url(#prefix__paint10_linear)"
          />
          <path
            d="M37.772 75.034c.29.03.563.21.76.436.204.227.338.5.448.767.104.273.186.54.296.796.11.255.238.505.435.714-.261-.133-.464-.372-.615-.627-.151-.256-.255-.529-.36-.79-.104-.262-.209-.517-.36-.744a1.506 1.506 0 00-.604-.552zM34.051 79.054c.21-.552.366-1.133.621-1.667.238-.558.79-.894.993-1.464.22-.563.099-1.179.145-1.766.047-.592.163-1.179.337-1.742a7.12 7.12 0 01.76-1.604c.331-.493.72-.947 1.179-1.324.9-.778 2.032-1.249 3.187-1.505-1.126.384-2.2.895-3.036 1.685a7.12 7.12 0 00-1.097 1.301c-.297.482-.54 1-.703 1.545a7.47 7.47 0 00-.348 1.667c-.064.53.081 1.197-.197 1.83-.134.314-.343.57-.564.785a2.718 2.718 0 00-.516.662c-.296.488-.482 1.069-.76 1.597zM42.04 72.96c-.326.97-.669 1.935-.947 2.922-.285.988-.39 2.01-.65 2.998l-.372 1.487c-.11.5-.279.987-.51 1.44-.465.907-1.139 1.726-2.015 2.266a5.803 5.803 0 001.045-1.092 5.92 5.92 0 00.755-1.278c.191-.459.354-.906.452-1.406l.343-1.493c.128-.493.244-.981.337-1.48.098-.506.203-1.023.377-1.511.342-.982.743-1.923 1.184-2.852z"
            fill="#B98B2D"
          />
          <path
            d="M52.907 52.513c-.087.128-.174.267-.279.418-.499.79-1.132 1.929-1.811 3.219-1.138 2.131-2.426 4.664-3.605 6.784-1.962 3.538-3.471 6.663-3.692 8.191-.395 2.666-.25 4.67-.61 5.484-.481-.18-1.236-.343-2.107-.419-.667-.07-1.399-.08-2.13-.017a3.79 3.79 0 00-.256.023c-.104.012-.209.023-.307.04-1.022.135-2.537.326-3.257.855-1.016.755-1.51 1.487-2.502 1.98-.232.117-.464.227-.697.326-1.3.57-2.542.889-3.628.9a4.559 4.559 0 01-1.515-.203 3.303 3.303 0 01-1.649-1.121 27.267 27.267 0 00-1.108-1.36c0-.005 0-.005-.006-.005l-.157-.175c-.447-.482-.906-.877-1.428-1.144-.081-.035-.163-.075-.244-.104-.58-.244-1.236-.32-2.02-.151.702-2.295.842-5.176.708-7.593a22.434 22.434 0 00-.191-2.056c-.041-.343-.093-.657-.146-.947-.476-2.55-1.288-5.943-1.921-7.947.963-1.58 3.587-2.939 7.03-4.014.813-.255 1.683-.5 2.606-.726 9.277-2.323 22.844-3.067 24.922-.238z"
            fill="url(#prefix__paint11_radial)"
          />
          <path
            d="M22.592 74.715c.313.482.662.941 1.039 1.365.377.424.784.82 1.22 1.18.434.365.893.696 1.38.987.488.29 1 .546 1.533.772a8.087 8.087 0 01-.836-.232 7.623 7.623 0 01-2.264-1.295 7.744 7.744 0 01-1.201-1.267c-.36-.47-.65-.976-.871-1.51zM38.77 75.127c-.475.128-.945.28-1.404.448a14.35 14.35 0 00-1.347.569c-.44.21-.87.441-1.288.691-.419.256-.825.529-1.225.82.33-.367.708-.698 1.114-.994.407-.29.836-.552 1.283-.767a8.83 8.83 0 011.4-.523c.481-.122.974-.209 1.468-.244z"
            fill="#36944D"
          />
          <path
            d="M37.18 74.006c-.458.355-.79.82-1.114 1.296-.32.476-.645.97-1.086 1.382-.447.407-.993.686-1.556.86-.563.18-1.155.22-1.73.22a8.221 8.221 0 001.643-.476 4.719 4.719 0 001.41-.86c.419-.36.761-.819 1.139-1.26.365-.453.778-.895 1.294-1.162z"
            fill="#36944D"
          />
          <path
            d="M49.284 52.246l-3.46 4.235c-3.994.104-12.893-2.295-17.85-3.736-.918.227-1.789.47-2.607.727-3.443 1.074-6.067 2.434-7.03 4.014.633 2.004 1.451 5.396 1.921 7.946.053.285.105.604.145.947.47 1.406 2.485 6.756 4.383 9.143.07.087.14.157.21.244.365.657.661 1.284.301 1.15-.61-.232-1.672-1.272-2.914-2.62.174 1.22.784 2.01 1.289 2.69.284.39.18.494-.093.447l.156.175c.006 0 .006 0 .006.006.378.418.738.882 1.11 1.359.429.546.992.918 1.648 1.121.516.07 1.033.14 1.515.203 1.085-.011 2.328-.337 3.628-.9a172.543 172.543 0 013.193-2.3c.847-.866 2.78-1.627 3.918-1.958 0 0-1.642.076-2.589.378.157-.25.587-1.058 1.005-1.505-.244.168-.976.447-1.637 1.278-.534.68-1.44 1.214-2.462 1.545-3.5.796-5.863-.586-7.651-2.8-1.759-2.155-3.129-6.453-4.604-10.915 2.282 5.072 6.48 8.493 8.534 8.748 2.125.273 5.556-1.847 9.126-5.803-3.35 2.62-5.974 3.672-8.058 3.497-2.026-.174-5.09-2.376-6.769-4.554 5.277 4.78 8.36 3.45 9.997 2.945 1.056-.33 4.8-2.654 8.4-5.791-1.388 2.759-3.64 6.97-5.422 9.068-2.682 2.433-5.956 4.165-8.8 3.473 2.194 1.505 5.061 1.034 7.238.244.976-.354 2.247-1.44 3.785-3.369 2.845-3.137 2.183 3.056 1.94 4.618.87.082 1.625.238 2.106.418.36-.807.215-2.811.61-5.483.226-1.528 1.736-4.653 3.692-8.19 1.173-2.121 2.467-4.654 3.605-6.786.68-1.284 1.312-2.422 1.811-3.218-1.614-.424-3.326-.691-3.326-.691zM31.387 77.538c-.83.622-1.434 1.551-1.434 1.551s-.488-.505-1.202-1.185c.819.07 1.69-.064 2.636-.366z"
            fill="url(#prefix__paint12_radial)"
          />
          <path
            d="M22.592 62.876a11.334 11.334 0 004.017 2.376c1.48.488 3.054.686 4.604.535 1.55-.152 3.041-.669 4.429-1.389 1.393-.714 2.694-1.609 3.994-2.503-1.23.981-2.496 1.94-3.884 2.7-1.381.767-2.914 1.325-4.505 1.482-1.59.151-3.204-.081-4.702-.616-1.503-.557-2.873-1.435-3.953-2.585z"
            fill="url(#prefix__paint13_radial)"
          />
          <path
            d="M26.122 64.265c.882.267 1.8.308 2.699.244a20.323 20.323 0 002.7-.401 25.53 25.53 0 002.64-.68c.871-.273 1.73-.587 2.572-.94-.8.446-1.643.83-2.508 1.143-.864.314-1.753.57-2.658.75-.906.18-1.817.308-2.746.337-.912.017-1.858-.087-2.7-.453z"
            fill="url(#prefix__paint14_radial)"
          />
          <path
            d="M20.955 62.725c.267.802.818 1.296 1.294 1.865.494.563.999 1.121 1.521 1.656 1.057 1.08 2.212 2.067 3.53 2.759a8.037 8.037 0 004.464.97c1.643-.128 3.402-.79 4.917-2.155-1.463 1.44-3.25 2.219-4.929 2.381a7.859 7.859 0 01-4.562-.923c-1.33-.709-2.485-1.737-3.524-2.858a34.625 34.625 0 01-1.48-1.725c-.46-.599-.993-1.14-1.231-1.97z"
            fill="url(#prefix__paint15_radial)"
          />
          <path
            d="M27.91 67.25c.72.465 1.55.663 2.409.663.876.005 1.776-.186 2.676-.511.917-.326 1.834-.785 2.746-1.313.928-.535 1.869-1.11 2.82-1.708-.916.685-1.816 1.376-2.745 1.963-.911.575-1.84 1.075-2.78 1.412-.93.325-1.864.476-2.758.412-.87-.07-1.701-.366-2.369-.918z"
            fill="url(#prefix__paint16_radial)"
          />
          <path
            d="M46.939 58.287a536.828 536.828 0 01-3.913 6.065c-1.26 1.928-2.537 3.793-3.948 5.46-1.375 1.627-2.89 3.05-4.528 4.049-.8.482-1.625.871-2.45 1.127a7.197 7.197 0 01-2.426.302c1.608-.017 3.251-.668 4.79-1.661 1.584-1.029 3.053-2.44 4.411-4.043 1.4-1.638 2.688-3.468 3.989-5.362 1.323-1.917 2.676-3.886 4.075-5.937z"
            fill="url(#prefix__paint17_radial)"
          />
          <path
            d="M20.125 63.544c.51 1.853 1.033 3.712 1.683 5.484.656 1.783 1.446 3.491 2.456 4.984a13.74 13.74 0 001.695 2.074 9.937 9.937 0 002.084 1.586c.766.43 1.59.737 2.461.918a7.417 7.417 0 002.752.023c-.935.22-1.88.267-2.78.14a7.933 7.933 0 01-2.538-.826 9.579 9.579 0 01-2.153-1.574 12.965 12.965 0 01-1.736-2.097c-1.016-1.522-1.788-3.282-2.403-5.106-.61-1.818-1.08-3.712-1.521-5.606z"
            fill="url(#prefix__paint18_radial)"
          />
          <path
            d="M43.23 65.827c-.204.477-.39.959-.546 1.44a18.222 18.222 0 00-.877 4.345 7.109 7.109 0 01-.04-1.451c.034-.494.115-.994.231-1.493.128-.494.29-.988.5-1.464.209-.47.453-.935.731-1.377z"
            fill="url(#prefix__paint19_radial)"
          />
          <path
            d="M51.292 56.556c-5.352 4.7-18.669 7.813-25.565 6.75-2.758-1.516-5.533-5.74-7.93-10.351-3.762-7.244-6.595-15.44-6.984-15.586-1.416-8.83-1.52-14.923.813-21.116C13.96 10.067 21.268-.494 38.005.017c6.896.21 12.434 2.626 16.59 6.315 5.94 5.263 9.08 13.128 9.382 20.883.505 13.198-5.991 23.45-12.684 29.341z"
            fill="url(#prefix__paint20_radial)"
          />
          <path
            d="M51.293 56.556c-5.353 4.7-18.67 7.813-25.566 6.75-2.758-1.516-5.533-5.74-7.93-10.351 10.623 1.417 24.01 2.608 27.714.255 3.041-5.176 4.47-15.33 5.073-23.956.203 2.434.203 10.555-.302 14.104.709-2.132 3.35-15.12 2.636-23.851 1.625 4.769 2.636 12.79 2.13 18.065 2.334-8.016 2.537-16.34 1.016-22.933 1.417 1.521 4.157 5.379 5.068 8.22 0-6.013-2.792-12.159-6.536-16.521 5.938 5.263 9.079 13.128 9.38 20.883.506 13.192-5.99 23.445-12.683 29.335z"
            fill="url(#prefix__paint21_linear)"
          />
          <path
            d="M51.81 43.527a54.134 54.134 0 01-2.259 6.244 56.78 56.78 0 01-2.99 5.937c-.557.958-1.155 1.911-1.944 2.724-.79.814-1.753 1.418-2.752 1.9a28.326 28.326 0 01-3.088 1.243 30.7 30.7 0 01-3.199.889 36.906 36.906 0 003.146-1.034c1.028-.395 2.05-.82 3.03-1.319.976-.5 1.905-1.104 2.654-1.888.754-.784 1.329-1.725 1.886-2.678a63.211 63.211 0 003.065-5.867 67.85 67.85 0 002.45-6.151z"
            fill="url(#prefix__paint22_radial)"
          />
          <path
            d="M58.77 36.294c-.645 2.574-1.313 5.141-2.195 7.645-.888 2.504-1.997 4.943-3.495 7.157-.748 1.103-1.573 2.149-2.426 3.166a32.364 32.364 0 01-2.746 2.898c-.981.9-2.043 1.72-3.187 2.4a13.485 13.485 0 01-3.675 1.498 14.045 14.045 0 003.594-1.632c1.109-.709 2.136-1.546 3.094-2.452.952-.912 1.834-1.893 2.682-2.904.842-1.017 1.66-2.057 2.403-3.143 1.492-2.172 2.63-4.577 3.553-7.052.929-2.486 1.654-5.036 2.398-7.58z"
            fill="url(#prefix__paint23_radial)"
          />
          <path
            d="M61.092 39.274a96.811 96.811 0 01-1.974 4.897c-.714 1.61-1.492 3.201-2.392 4.723-.9 1.516-1.921 2.974-3.082 4.305a20.386 20.386 0 01-3.942 3.508c1.393-1.075 2.641-2.324 3.762-3.665 1.126-1.342 2.119-2.794 3.007-4.305.894-1.504 1.695-3.073 2.45-4.659.754-1.585 1.457-3.195 2.17-4.804z"
            fill="url(#prefix__paint24_radial)"
          />
          <path
            d="M49.336 31.851c0 .372-.006.738-.011 1.11l-.018.575c-.006.377-.023.75-.04 1.121-.018.47-.047.935-.082 1.4-.029.47-.07.935-.104 1.4l-.018.174a41.24 41.24 0 01-.197 1.888c-.03.244-.058.482-.093.72-.04.32-.087.622-.133.913-.059.395-.122.766-.192 1.109a.17.17 0 00-.012.052c-.017.105-.034.21-.058.308-.023.128-.052.25-.08.378-.03.029-.07.052-.1.081-.267.215-.574.4-.923.57-7.941 3.688-36.81-6.13-36.81-6.13-.052-.36-.093-.8-.122-1.324-.006-.075-.006-.15-.012-.238a5.953 5.953 0 01-.017-.459c-.006-.04-.006-.093-.006-.139-.011-.145-.011-.296-.011-.447v-.175a27.37 27.37 0 010-.975 53.266 53.266 0 01.064-1.836c.017-.39.04-.779.075-1.162.006-.099.011-.197.023-.29.035-.454.076-.895.122-1.342.046-.465.104-.924.163-1.389.052-.464.122-.923.197-1.388.133-.86.284-1.72.47-2.568.052-.267.11-.534.168-.795.012-.07.03-.128.047-.192.058-.273.128-.546.197-.813.093-.372.198-.738.296-1.104a22.492 22.492 0 01.447-1.324c.145-.419.325-.854.523-1.302.093-.215.191-.424.284-.639.204-.424.407-.842.627-1.254.11-.21.22-.413.337-.616 1.48-2.632 3.605-5.38 6.386-7.308.005-.006.011-.011.023-.017.302-.215.621-.407.946-.604.081-.047.151-.1.232-.146.169-.104.349-.197.523-.29.046-.023.098-.046.15-.081.192-.093.378-.18.575-.268a13.385 13.385 0 014.865-1.161c.43-.018.86-.03 1.277-.018.227 0 .447.006.662.012.209.006.412.017.615.035.087 0 .169.006.256.017.238.012.476.035.708.07.226.023.453.052.668.093.197.023.383.052.58.093.14.023.279.052.418.081.14.023.279.052.418.093.174.035.354.081.528.128.215.052.424.11.639.168a.271.271 0 00.081.023c.412.122.825.268 1.23.419.262.098.518.203.779.308.098.04.197.087.29.127.97.43 1.887.936 2.752 1.505.029.023.07.046.104.075.61.407 1.19.854 1.747 1.33a20.073 20.073 0 01.848.762l.006.005c.412.396.807.808 1.184 1.238.006.011.012.017.023.029.378.435.75.889 1.092 1.36.284.377.545.76.79 1.155.121.198.243.395.365.598.244.419.482.849.697 1.278.098.198.191.39.278.587.081.151.145.308.215.465.116.267.226.54.33.83a19.974 19.974 0 01.773 2.673c.197.854.36 1.742.482 2.66.029.227.058.447.093.668.023.22.046.436.08.65a55.894 55.894 0 01.29 6.46z"
            fill="url(#prefix__paint25_radial)"
          />
          <path
            d="M49.336 31.85c0 .372-.006.738-.011 1.11l-.018.575c-.006.378-.023.75-.04 1.121-.018.47-.047.936-.082 1.4-.029.47-.07.936-.104 1.4l-.018.174c-.052.657-.122 1.29-.197 1.888-.029.244-.058.483-.093.72-.04.32-.087.622-.133.913-.058.395-.122.766-.192 1.11a.17.17 0 00-.012.051c-.017.105-.034.21-.058.308-.023.128-.052.25-.08.378-.03.029-.07.052-.1.081-.267.215-.574.401-.923.57l-.754-1.912c-.598-4.6-3.855-13.035-3.948-13.296 2.427 2.742 4.052 5.78 4.36 6.39-.302-4.874-1.324-10.66-2.74-13.6 1.62 1.523 3.442 6.698 3.651 7.512-.853-7.93-2.49-13.78-6.054-18.333.284.238.557.488.83.743l.017.018.006.006a19.855 19.855 0 012.299 2.625c.284.378.545.761.79 1.156.121.198.243.395.365.598.244.419.482.848.697 1.278.098.198.191.39.278.587.081.151.145.308.215.465.116.267.226.54.33.83a19.99 19.99 0 01.64 2.098c.046.191.092.383.133.575.197.854.36 1.742.482 2.66.029.227.058.447.093.668.023.22.046.436.081.65.075.68.128 1.366.174 2.046.099 1.475.134 2.974.116 4.438z"
            fill="url(#prefix__paint26_radial)"
          />
          <path
            d="M13.147 24.514c-.459.97-.86 1.957-1.202 2.962a33.433 33.433 0 00-.87 3.068 43.77 43.77 0 00-.622 3.125c-.052.354-.11.708-.156 1.063a27.37 27.37 0 010-.976c0-.174.005-.36.011-.546.122-.918.29-1.83.505-2.736.25-1.04.557-2.068.946-3.067.384-1 .842-1.975 1.388-2.893z"
            fill="url(#prefix__paint27_radial)"
          />
          <path
            d="M48.373 42.58a.074.074 0 01.005.035v.011c-.023.128-.052.25-.081.378-.029.029-.07.052-.099.081a42.3 42.3 0 00-1.021-4.455c-.25-.86-.523-1.708-.825-2.55.395.801.732 1.638 1.022 2.492.29.848.528 1.713.731 2.59.11.465.198.941.268 1.418z"
            fill="url(#prefix__paint28_radial)"
          />
          <path
            d="M48.64 41.122c.005.011.005.017 0 .029-.059.395-.122.766-.192 1.11v-.111l-.017-.494a83.935 83.935 0 00-.285-4.53 78.326 78.326 0 00-.517-4.514 97.532 97.532 0 00-.748-4.485 53.26 53.26 0 01.958 4.45c.255 1.498.458 3.003.597 4.52.105 1.248.175 2.508.204 3.763 0 .093.011.175 0 .262z"
            fill="url(#prefix__paint29_radial)"
          />
          <path
            d="M49.336 31.85c0 .372-.006.738-.011 1.11l-.018.575c-.006.378-.023.75-.04 1.121-.018.47-.047.936-.082 1.4-.029.47-.07.936-.104 1.4l-.018.174a52.078 52.078 0 01-.29 2.609c-.04.296-.087.592-.133.883-.053.377-.122.749-.192 1.12v.018a.17.17 0 00-.012.053c-.017.104-.04.203-.058.296v.011c-.023.128-.052.25-.08.378.022-.14.051-.285.075-.424.029-.145.052-.285.08-.424.07-.424.134-.86.18-1.284.152-1.139.25-2.277.332-3.421.127-1.865.18-3.73.15-5.589-.028-3.723-.301-7.464-1.224-11.048-.947-3.538-2.903-6.808-5.544-9.335a18.576 18.576 0 00-9.637-4.868c-3.587-.622-7.419-.436-10.582 1.417-3.176 1.807-5.626 4.717-7.483 7.883-.923 1.603-1.701 3.294-2.247 5.048-.534 1.772-.929 3.596-1.242 5.431a57.33 57.33 0 00-.685 5.542c-.122 1.865-.21 3.735-.012 5.6a19.704 19.704 0 01-.122-1.325c-.006-.075-.006-.15-.011-.238a5.953 5.953 0 01-.018-.459c-.006-.04-.006-.093-.006-.139-.005-.151-.005-.302-.005-.453a38.018 38.018 0 010-1.15c.011-.616.04-1.232.07-1.842.017-.389.04-.778.075-1.162.005-.098.011-.197.023-.29.035-.453.075-.895.122-1.342.046-.465.104-.924.162-1.388.053-.465.122-.924.198-1.389.133-.86.284-1.719.47-2.567.052-.267.11-.535.168-.796.012-.07.03-.128.047-.192.058-.273.127-.546.197-.813.093-.372.197-.738.296-1.104a22.492 22.492 0 01.447-1.324c.163-.436.343-.877.523-1.301.093-.215.191-.424.284-.64.203-.423.407-.841.627-1.254.11-.21.22-.412.337-.616 1.834-3.241 4.336-6.192 7.581-8.074.169-.105.349-.198.523-.29.046-.024.098-.047.15-.082a13.812 13.812 0 014.62-1.342 19.4 19.4 0 013.63-.046c.238.011.476.035.708.07.226.023.453.052.668.092.197.024.383.053.58.093.14.024.279.053.418.082.14.023.279.052.418.093.174.034.354.08.528.127.215.053.424.11.639.169a.27.27 0 00.081.023 19.126 19.126 0 017.75 4.525c.848.802 1.614 1.69 2.305 2.632.273.377.54.76.79 1.156.121.197.243.395.365.598.244.418.482.848.697 1.278a20.842 20.842 0 01.819 1.876 19.971 19.971 0 01.614 2.01c.006.03.012.053.018.087.046.192.093.384.133.575.198.883.354 1.772.482 2.66.03.228.058.448.093.669.023.22.046.436.081.65.076.68.128 1.366.175 2.045.104 1.47.133 2.957.127 4.433z"
            fill="url(#prefix__paint30_radial)"
          />
          <path
            d="M48.303 43.004c-.557 2.742-1.626 8.423-3.297 12.077-1.713 3.74-4.871 5.234-7.96 6.192-3.1.964-7.36 2.335-11.314 2.027a7.553 7.553 0 01-.98-.145c-3.048-.633-6.793-3.055-9.213-5.193a16.972 16.972 0 01-1.62-1.609c-2.09-2.428-2.13-5.222-1.91-7.546.006-.11.018-.22.03-.325.051-.517.086-.976.092-1.389.029-1.295-.14-2.155-.29-2.921-.203-1.017-.511-1.464-1.092-3.404-.15-.506-.36-1.441-.487-2.318a8.552 8.552 0 01-.122-1.232c-.035-1.388.15-2.16.29-3.828v-.011c.795-5.751 5.666-11.84 12.208-12.095 8.36-.325 20.336 8.063 25.665 21.72z"
            fill="url(#prefix__paint31_radial)"
          />
          <path
            d="M48.303 43.004c-.557 2.742-1.626 8.423-3.297 12.077-1.713 3.74-4.871 5.233-7.96 6.192-3.1.964-7.36 2.335-11.314 2.027a7.548 7.548 0 01-.98-.145c3.906.081 8.138-1.232 11.052-1.963 3.652-.912 7.303-3.73 8.14-5.63.835-1.905 1.601-4.948 2.96-13.674-1.452-3.31-5.091-8.864-7.907-11.681-2.81-2.818-10.797-8.528-17.49-7.616-6.48.895-9.76 6.97-11.083 10.782.796-5.751 5.666-11.84 12.209-12.095 8.365-.32 20.34 8.069 25.67 21.726z"
            fill="url(#prefix__paint32_linear)"
          />
          <path
            opacity={0.4}
            d="M37.07 59.408a4.907 4.907 0 004.905-4.908 4.907 4.907 0 00-4.905-4.909 4.907 4.907 0 00-4.905 4.909 4.907 4.907 0 004.905 4.908z"
            fill="url(#prefix__paint33_radial)"
          />
          <path
            opacity={0.4}
            d="M18.546 53.43a4.901 4.901 0 01-3.013 4.532 16.96 16.96 0 01-1.62-1.61c-2.09-2.427-2.13-5.221-1.91-7.545a4.916 4.916 0 011.637-.279 4.903 4.903 0 014.906 4.903z"
            fill="url(#prefix__paint34_radial)"
          />
          <path
            d="M35.061 49.91c4.582 0 8.296-3.716 8.296-8.3 0-4.585-3.714-8.301-8.296-8.301-4.581 0-8.295 3.716-8.295 8.3 0 4.585 3.714 8.302 8.295 8.302z"
            fill="url(#prefix__paint35_radial)"
          />
          <path
            d="M22.76 41.61a6.734 6.734 0 01-10.64 5.489c.028-1.295-.14-2.155-.29-2.922-.204-1.016-.512-1.464-1.092-3.404-.151-.505-.36-1.44-.488-2.318a4.668 4.668 0 01-.011-.284 6.734 6.734 0 015.787-3.288c3.721-.012 6.734 3.003 6.734 6.727z"
            fill="url(#prefix__paint36_radial)"
          />
          <path
            d="M22.975 55.249c1.6 0 2.897-1.298 2.897-2.899a2.898 2.898 0 10-2.897 2.899z"
            fill="url(#prefix__paint37_radial)"
          />
          <path
            d="M32.908 37.503a6.16 6.16 0 012.09-.744 6.454 6.454 0 012.24.023c.738.14 1.452.419 2.09.802a6.026 6.026 0 011.666 1.47 8 8 0 00-1.776-1.267 7.53 7.53 0 00-2.038-.714 7.24 7.24 0 00-2.153-.099 7.984 7.984 0 00-2.12.529z"
            fill="#BC7757"
          />
          <path
            d="M44.89 40.454c-1.446 0-2.508-1.104-3.275-1.83-.725-.686-2.647-1.656-4.638-1.464-.023 0-.046.006-.07.006-.075.011-.156.011-.232.023-.006 0-.017.006-.023.006a6.078 6.078 0 00-.714.11c-2.287.494-4.099 2.05-5.219 4.072-.662 1.197-1.132 2.608-1.12 3.985.011 1.307.638 2.022 1.805 2.515 2.433 1.034 5.631 1.14 8.07.093 1.253-.534 2.414-1.434 3.059-2.654.516-.976.62-2.086.452-3.155.807-.098 1.516-.633 1.904-1.707z"
            fill="url(#prefix__paint38_radial)"
          />
          <path
            d="M29.738 46.402c.406 1.522 3.553 2.23 6.287 2.08 2.734-.151 5.428-1.673 6.136-4.009.708-2.335-.964-6.494-4.87-6.494-5.527 0-8.267 5.757-7.553 8.423z"
            fill="url(#prefix__paint39_radial)"
          />
          <path
            d="M36.635 48.476a4.326 4.326 0 004.324-4.328 4.326 4.326 0 00-4.325-4.328 4.326 4.326 0 00-4.324 4.328 4.326 4.326 0 004.325 4.328z"
            fill="url(#prefix__paint40_radial)"
          />
          <path
            d="M36.635 48.476a4.326 4.326 0 004.324-4.328 4.326 4.326 0 00-4.325-4.328 4.326 4.326 0 00-4.324 4.328 4.326 4.326 0 004.325 4.328z"
            fill="url(#prefix__paint41_radial)"
          />
          <path
            d="M36.635 47.267a3.118 3.118 0 003.117-3.119 3.118 3.118 0 10-3.117 3.12z"
            fill="#222223"
          />
          <path
            d="M39.015 43.132a.645.645 0 100-1.29.645.645 0 000 1.29zM35.212 46.483a.325.325 0 100-.65.325.325 0 000 .65z"
            fill="#fff"
          />
          <path
            d="M37.29 38.932c3.21 0 4.906 2.556 5.022 4.647.128-2.364-1.579-5.594-5.021-5.594-4.981 0-7.686 4.664-7.657 7.54.156-2.637 2.85-6.593 7.657-6.593z"
            fill="url(#prefix__paint42_linear)"
          />
          <path
            d="M25.326 51.607c-.046.07-.099.128-.15.197-.773.93-1.986 1.546-3.478 1.36-1.602-.21-3.019-1.424-3.5-2.312-.25-.46-.372-.86-.268-1.145.076-.203.256-.337.598-.377.807-.099 1.777-.482 2.537-1.493.76-1.017 1.01-2.184 1.091-4.037 3.756 1.359 3.93 6.767 3.17 7.807z"
            fill="url(#prefix__paint43_linear)"
          />
          <path
            d="M22.464 45.542a4.13 4.13 0 01-.098 1.662 3.831 3.831 0 01-.807 1.504c-.39.43-.894.755-1.44.935-.546.186-1.15.198-1.672 0a3.818 3.818 0 001.55-.325 3.549 3.549 0 001.248-.895c.354-.377.621-.83.824-1.318.198-.488.337-1.01.395-1.563z"
            fill="#FFF5DB"
          />
          <path
            d="M25.175 51.798c-.772.93-1.985 1.546-3.477 1.36-1.602-.21-3.019-1.423-3.5-2.312-.25-.46-.372-.86-.268-1.144 1.48 1.48 3.954 2.52 7.245 2.096z"
            fill="url(#prefix__paint44_linear)"
          />
          <path
            d="M22.15 43.794c-.052 1.12-.144 2.277-.644 3.305-.487 1.01-1.387 1.859-2.49 2.132-.267.087-.563.064-.824.192-.28.116-.349.459-.28.726.135.552.454 1.04.843 1.446.783.808 1.81 1.406 2.937 1.563-1.167.064-2.328-.482-3.222-1.29a4.092 4.092 0 01-.604-.72 2.988 2.988 0 01-.389-.906 1.345 1.345 0 01.006-.645.96.96 0 01.505-.575c.198-.105.43-.128.546-.14a2.75 2.75 0 00.372-.063c.986-.221 1.782-.947 2.322-1.854.522-.929.72-2.056.923-3.171z"
            fill="#BC7757"
          />
          <path
            d="M9.6 39.35c.836.43 1.956.215 2.914-.354.813-.483 2.549-1.534 4.389-.837 1.672.633 2.606 2.626 2.955 3.445.435 1.022.743 2.23.737 3.41-.006 1.115-.418 1.725-1.184 2.149-1.597.883-3.42 1.098-5.016.21-.819-.46-1.66-1.39-2.078-2.435-.337-.836-.482-1.673-.494-2.66-.528-.087-2.124-.57-2.223-2.928z"
            fill="url(#prefix__paint45_radial)"
          />
          <path
            d="M20.502 45.903c-.267 1.3-2.328 1.91-4.122 1.777-1.793-.128-3.192-1.487-3.767-3.456-.784-2.69.377-5.525 2.931-5.525 3.629 0 5.422 4.92 4.958 7.204z"
            fill="url(#prefix__paint46_radial)"
          />
          <path
            d="M18.795 48a3.943 3.943 0 003.942-3.945 3.943 3.943 0 10-7.883 0A3.943 3.943 0 0018.795 48z"
            fill="url(#prefix__paint47_radial)"
          />
          <path
            d="M18.795 48a3.943 3.943 0 003.942-3.945 3.943 3.943 0 10-7.883 0A3.943 3.943 0 0018.795 48z"
            fill="url(#prefix__paint48_radial)"
          />
          <path
            d="M18.795 46.902a2.845 2.845 0 002.845-2.847 2.845 2.845 0 10-2.845 2.847z"
            fill="#222223"
          />
          <path
            d="M18.865 42.574a.592.592 0 100-1.185.592.592 0 000 1.185zM16.45 45.89a.296.296 0 100-.591.296.296 0 000 .592z"
            fill="#fff"
          />
          <path
            d="M15.55 39.501c3.152 0 4.917 3.387 5.016 5.64.017-2.462-1.753-6.442-5.016-6.442-2.107 0-3.262 1.923-3.17 4.102.088-1.801 1.225-3.3 3.17-3.3z"
            fill="url(#prefix__paint49_linear)"
          />
          <path
            d="M10.221 38.362c.69-1.707 1.59-2.585 2.758-3.032 1.19-.459 2.983-.494 4.307-.75 1.318-.255 1.927-1.266 2.13-2.282-1.468.738-2.902 1.051-4.54 1.266-1.723.227-2.96.784-3.622 1.702-.661.918-.928 1.755-1.033 3.096z"
            fill="url(#prefix__paint50_radial)"
          />
          <path
            d="M26.963 30.555c.354 1.319.83 1.8 2.05 2.056 1.218.256 4.498-.54 6.321-.644 1.991-.116 3.866-.29 6.908 2.712-1.486-2.358-2.687-3.502-4.806-4.048-1.66-.43-4.07 0-6.96.226-1.771.145-2.572.169-3.513-.302z"
            fill="url(#prefix__paint51_radial)"
          />
          <path
            d="M31.37 54.145c-1.748.947-3.687 1.51-5.655 1.795-.981.14-1.98.21-2.972.157a7.9 7.9 0 01-1.475-.203 6.023 6.023 0 01-1.381-.552c.51.081 1.016.145 1.468.21.465.034.935.08 1.411.092.952.076 1.927.017 2.891-.099.964-.14 1.933-.261 2.88-.505l1.422-.39c.482-.156.94-.33 1.41-.505z"
            fill="#BC7757"
          />
          <path
            d="M22.441 56.881c0 .047.493 1.888 2.032 1.923 1.538.035 1.892-2.045 1.887-2.097-.703.691-3.49.848-3.919.174z"
            fill="url(#prefix__paint52_radial)"
          />
          <path
            d="M22.842 57.16c.487.331 1.927.331 3.216-.197-1.08 1.452-2.363 1.603-3.216.197z"
            fill="#BC7757"
          />
          <path
            opacity={0.4}
            d="M31.137 55.145a.958.958 0 100-1.917.958.958 0 000 1.916z"
            fill="url(#prefix__paint53_radial)"
          />
          <path
            opacity={0.4}
            d="M19.875 56.184a.958.958 0 100-1.916.958.958 0 000 1.916z"
            fill="url(#prefix__paint54_radial)"
          />
          <path
            d="M30.365 53.547c.203 0 .4.052.586.134a1.663 1.663 0 01.87.825c.094.18.152.383.152.586-.116-.162-.226-.32-.342-.459a4.899 4.899 0 00-.372-.4 3.508 3.508 0 00-.412-.36 3.494 3.494 0 00-.482-.326z"
            fill="#BC7757"
          />
          <path
            d="M37.557 84.079c-1.073.825-3.506.75-4.771.418-1.266-.337-1.289-.36-2.717-.279-1.417.076-2.485-.813-3.019-1.22-.528-.406-.963-1.423-.203-2.637s1.016-1.12 2.281-1.098c1.266.024 3.814-.104 4.917-.215 2.09.146 3.385 1.516 3.605 3.288a4.577 4.577 0 01-.093 1.743z"
            fill="url(#prefix__paint55_radial)"
          />
          <path
            d="M37.557 84.079c-1.073.825-3.506.75-4.771.418-1.266-.337-1.289-.36-2.717-.279-1.417.076-2.485-.813-3.019-1.22-.528-.406-.963-1.423-.203-2.637s1.016-1.12 2.281-1.098c1.266.024 3.814-.104 4.917-.215-.836.47-3.042 3.16 1.016 4.171.993.25 2.009-.308 2.59-.883a4.577 4.577 0 01-.094 1.743z"
            fill="url(#prefix__paint56_linear)"
          />
          <path
            d="M33.546 78.729c.349-.21.737-.349 1.144-.418.406-.064.83-.064 1.236.017a3.52 3.52 0 011.15.453c.354.215.661.494.9.825a4.97 4.97 0 00-1.005-.639 4.409 4.409 0 00-1.103-.372 4.313 4.313 0 00-1.16-.081 5.1 5.1 0 00-1.162.215zM32.791 79.345a3.905 3.905 0 00-1.004 1.789c-.052.22-.098.453-.11.697a1.838 1.838 0 01-.105-.732 2.26 2.26 0 01.18-.726 2.24 2.24 0 01.424-.616c.18-.18.39-.325.615-.412z"
            fill="#B98B2D"
          />
          <path
            d="M37.267 81.047a3.519 3.519 0 00-1.335-1.43c-.569-.342-1.225-.516-1.88-.563a53.55 53.55 0 01-4.918.215c.412-.064.819-.11 1.225-.168l1.225-.134c.813-.081 1.631-.145 2.438-.21h.053c.696.059 1.398.268 1.973.68.575.39 1.022.97 1.22 1.61zM27.056 82.999c.79.47 1.602.912 2.461.958.413.023.86-.035 1.336-.052.464-.035.992.029 1.44.15.458.128.864.25 1.305.314.436.076.883.093 1.33.128a7.32 7.32 0 001.335-.046 3.495 3.495 0 001.289-.372c-.76.534-1.724.627-2.624.65a9.123 9.123 0 01-2.711-.377 4.472 4.472 0 00-1.359-.169c-.458 0-.917.076-1.37.012-.923-.116-1.724-.633-2.432-1.196z"
            fill="#B98B2D"
          />
          <path
            d="M24.786 80.716c-1.167-.093-1.788-.64-2.16-1.307-.144-.262-.26-.483-.377-.68a5.17 5.17 0 00-.644-.912c-.47-.517-.714-.64-1.01-.9-.255-.227-.296-.43-.232-.558a.121.121 0 01.035-.058.488.488 0 01.551-.087c.238.127.505.22.981.621.052.04.11.093.168.14.03.029.07.058.1.093a2.965 2.965 0 00-.448-.622 2.916 2.916 0 00-.133-.14c-.262-.25-.476-.4-.668-.575-.203-.174-.366-.406-.348-.61a.26.26 0 01.07-.18c.18-.232.487-.139.742.024.233.145.61.337 1.132.772l.14.122a2.86 2.86 0 00-.238-.406 5.438 5.438 0 00-1.22-1.25c-.26-.197-.324-.418-.266-.592a.388.388 0 01.307-.261c.349-.076.807.203 1.208.505.325.25.61.535 1.039 1.01.087.1.168.198.273.309-.018-.04-.035-.087-.058-.134-.006-.006-.012-.011-.012-.017a4.485 4.485 0 00-.33-.517l-.007-.012c-.267-.354-.58-.703-.725-.894-.203-.256-.285-.605-.14-.79v-.006a.303.303 0 01.157-.116c.354-.117.766.29.975.453.215.156.767.9.923 1.156.163.255.697 1.179.836 1.434.14.25.645 1.313 1.04 2.382.046.883-.494 2.695-1.66 2.603z"
            fill="url(#prefix__paint57_linear)"
          />
          <path
            d="M21.715 77.695c.244.331.639.912.639.912l-.105.116a5.17 5.17 0 00-.644-.912c-.47-.517-.714-.639-1.01-.9-.255-.227-.296-.43-.232-.558.075.151.273.39.516.575.343.244.598.436.836.767z"
            fill="url(#prefix__paint58_linear)"
          />
          <path
            d="M22.035 76.423c.174.209.679.935.9 1.522-.337-.517-.47-.651-.738-.89a2.963 2.963 0 00-.447-.62c-.04-.047-.087-.094-.133-.14-.262-.25-.476-.4-.668-.575-.203-.174-.366-.407-.348-.61.11.203.348.395.453.488.18.157.8.621.98.825z"
            fill="url(#prefix__paint59_linear)"
          />
          <path
            d="M22.342 74.976c.192.174 1.167 1.499 1.41 2.144-.336-.384-.725-.872-1.061-1.272a2.854 2.854 0 00-.238-.407 5.435 5.435 0 00-1.22-1.249c-.26-.197-.325-.418-.267-.592.03.122.128.267.325.412.349.267.854.79 1.051.964z"
            fill="url(#prefix__paint60_linear)"
          />
          <path
            d="M22.662 73.588c-.204-.256-.285-.604-.14-.79 0 .232.151.523.424.836.435.506.644.75.836.982.192.227.755 1.51.784 1.632a35.16 35.16 0 00-.848-1.231 4.502 4.502 0 00-.33-.517l-.007-.012c-.26-.354-.574-.703-.72-.9z"
            fill="url(#prefix__paint61_linear)"
          />
          <path
            d="M22.94 77.945a4.619 4.619 0 01-.377-.378c-.134-.151-.238-.273-.348-.395-.088-.11-.175-.22-.28-.349.082.064.175.146.268.233a3.162 3.162 0 00-.441-.622c.093.064.186.128.267.198.133.116.261.244.377.383a4.6 4.6 0 01.314.436c.08.163.162.325.22.494zM23.753 77.126c-.157-.134-.29-.28-.43-.424-.127-.151-.26-.297-.383-.442-.128-.157-.244-.314-.36-.47l-.04-.059c.052.041.098.082.15.128a3.288 3.288 0 00-.243-.418c.093.07.18.145.267.22.145.14.284.285.412.436a3.7 3.7 0 01.348.488c.11.175.21.349.279.54zM24.595 76.37c-.14-.162-.262-.33-.383-.5a16.953 16.953 0 00-.355-.499c-.104-.162-.209-.32-.336-.51.081.092.174.19.273.307a3.317 3.317 0 00-.401-.668c.093.07.186.157.267.244.145.157.279.314.406.488.122.174.227.354.314.546.087.186.168.383.215.592z"
            fill="#BC7757"
          />
          <path
            d="M30.702 81.07c-.494.953-1.713 1.749-2.624 1.94-.912.192-1.748.913-2.624 1.372a4.91 4.91 0 01-.836.33c-.836.262-1.87.396-2.665.28-1.294-.192-2.513-.761-2.815-2.057-.006-.035-.018-.075-.023-.11-.29-1.255-.505-2.55.255-3.544.877-1.138 2.13-1.37 3.466-1.522 1.335-.15 2.13.041 3.5-.644 1.37-.686 2.903-.512 3.536-.117.325.204.655 1 .853 1.865.18.837.22 1.737-.023 2.207z"
            fill="url(#prefix__paint62_radial)"
          />
          <path
            d="M30.702 81.07c-.494.953-1.713 1.748-2.624 1.94-.912.192-1.748.912-2.624 1.371a4.91 4.91 0 01-.836.331c-.836.261-1.87.395-2.665.279-1.294-.192-2.513-.761-2.815-2.056-.006-.035-.018-.076-.023-.11.545.348 1.207.528 1.852.795.725.296 1.985.25 2.49-.372.395-.488.046-1.51.482-1.777.534-.331 1.062.25 1.8.383.626.11 1.37.151 2.078-.023.708-.174 1.27-1.778 1.317-2.562a2.31 2.31 0 011.59-.407c.18.837.221 1.737-.022 2.208z"
            fill="url(#prefix__paint63_linear)"
          />
          <path
            d="M24.049 81.65c.058.14.134.268.226.378.099.105.215.198.314.302.226.192.453.372.702.506.244.14.517.22.801.267.285.047.587.076.889.116a3.947 3.947 0 01-.912.093 2.12 2.12 0 01-.911-.232 2.86 2.86 0 01-.714-.599c-.093-.127-.198-.243-.273-.383-.07-.14-.11-.296-.122-.447zM24.624 84.712l.836-.337c.267-.14.522-.302.777-.459.511-.32 1.016-.656 1.591-.842a4.476 4.476 0 001.649-.703c.493-.343.94-.772 1.225-1.301-.175.598-.61 1.098-1.092 1.493-.244.209-.516.366-.807.511-.145.076-.302.122-.458.174-.174.047-.302.076-.43.116-.517.157-1.016.477-1.556.75-.272.14-.545.279-.83.395-.307.075-.604.157-.905.203zM29.872 76.998a3.066 3.066 0 00-1.347-.192 4.352 4.352 0 00-1.312.227c-.424.14-.784.342-1.248.552a5.07 5.07 0 01-1.423.36c-.481.035-.946.029-1.399.064-.452.029-.911.093-1.358.145-.888.122-1.747.453-2.41 1.127.564-.755 1.458-1.185 2.363-1.36.912-.191 1.847-.22 2.77-.284a4.69 4.69 0 001.352-.32c.43-.174.836-.412 1.295-.517a4.608 4.608 0 011.381-.15c.459.028.93.11 1.336.348z"
            fill="#B98B2D"
          />
          <path
            d="M30.73 77.108c-.208-.209-.533-.226-.864-.116-.331.116-1.063 1.127-.738 2.271.331 1.145 1.028 1.772 1.574 1.801.61.035.772-.691.644-1.196-.07-.558-.284-2.429-.615-2.76z"
            fill="url(#prefix__paint64_radial)"
          />
          <path
            d="M34.678 77.387c-.255.534-.412 1.115-.627 1.667-.813.511-2.49 1.29-2.943 1.307-1.503-.813-1.167-2.742-.372-3.253.622-.302 1.347-.4 2.386-.285.61.07 1.278.18 1.73.262-.07.093-.133.197-.174.302z"
            fill="url(#prefix__paint65_linear)"
          />
        </g>
        <defs>
          <radialGradient
            id="prefix__paint0_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.15583 0 0 7.16054 11.88 81.793)"
          >
            <stop stopColor="#FFDC4B" />
            <stop offset={0.51} stopColor="#F7CD48" />
            <stop offset={1} stopColor="#EEBB45" />
          </radialGradient>
          <radialGradient
            id="prefix__paint2_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.02281 0 0 1.02348 41.942 75.93)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint3_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(12.5136 0 0 12.5218 35.048 86.398)"
          >
            <stop offset={0.443} stopColor="#FFDC4B" />
            <stop offset={0.727} stopColor="#F7CD48" />
            <stop offset={1} stopColor="#EEBB45" />
          </radialGradient>
          <radialGradient
            id="prefix__paint5_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.50857 -1.07162 1.0723 7.51332 34.128 87.224)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint6_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.5379 0 0 1.53891 25.615 86.04)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint7_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.8447 0 0 1.84591 39.775 84.308)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint8_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(10.5079 0 0 10.5148 33.6 77.81)"
          >
            <stop stopColor="#FFDC4B" />
            <stop offset={0.51} stopColor="#F7CD48" />
            <stop offset={1} stopColor="#EEBB45" />
          </radialGradient>
          <radialGradient
            id="prefix__paint11_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(15.0048 0 0 15.0147 27.407 74.772)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint12_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(15.6566 0 0 15.6669 35.484 66.267)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint13_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.20651 0 0 6.21059 31.11 64.005)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint14_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(3.83598 0 0 3.83851 31.428 63.601)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint15_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.16025 0 0 6.1643 28.815 66.483)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint16_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(4.00003 0 0 4.00266 33.238 66.279)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint17_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(8.56711 0 0 8.57276 38.309 66.797)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint18_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.11978 0 0 7.12446 26.69 71.182)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint19_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.11214 0 0 2.11353 42.49 68.724)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint20_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(44.2054 0 0 44.2345 30.052 7.195)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint22_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(8.81569 0 0 8.8215 43.692 52.996)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint23_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(10.7626 0 0 10.7696 49.907 48.674)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint24_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.35999 0 0 7.36484 55.398 47.991)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint25_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(25.8485 0 0 25.8655 23.178 15.244)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint26_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(12.0446 0 0 12.0526 45.565 27.03)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint27_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(3.74908 0 0 3.75154 11.72 29.623)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint28_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.57575 0 0 2.57744 47.37 39.581)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint29_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(5.03114 0 0 5.03446 47.765 35.196)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint30_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(19.0532 0 0 19.0658 29.815 24.42)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <radialGradient
            id="prefix__paint31_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(26.1304 0 0 26.1476 23.41 44.058)"
          >
            <stop offset={0.598} stopColor="#FFE3B7" />
            <stop offset={0.688} stopColor="#FDD8AC" />
            <stop offset={0.846} stopColor="#F8BA91" />
            <stop offset={1} stopColor="#F29770" />
          </radialGradient>
          <radialGradient
            id="prefix__paint33_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(4.9057 0 0 4.90892 37.07 54.5)"
          >
            <stop stopColor="#DD6162" />
            <stop offset={1} stopColor="#DF6263" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint34_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(4.74402 0 0 4.74714 13.404 53.474)"
          >
            <stop stopColor="#DD6162" />
            <stop offset={1} stopColor="#DF6263" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint35_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(8.29276 0 0 8.29822 35.062 41.609)"
          >
            <stop stopColor="#F29770" />
            <stop offset={1} stopColor="#F29871" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint36_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.50002 0 0 6.5043 15.996 41.559)"
          >
            <stop stopColor="#F29770" />
            <stop offset={1} stopColor="#F29871" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint37_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.89741 0 0 2.89932 22.977 52.35)"
          >
            <stop stopColor="#F29770" />
            <stop offset={1} stopColor="#F29871" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint38_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.77797 0 0 6.78242 37.243 42.925)"
          >
            <stop offset={0.18} stopColor="#2E2B27" />
            <stop offset={0.605} stopColor="#322E2A" />
            <stop offset={0.99} stopColor="#3D3935" />
            <stop offset={1} stopColor="#3D3935" />
          </radialGradient>
          <radialGradient
            id="prefix__paint39_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(9.86637 0 0 9.87286 36.278 43.953)"
          >
            <stop offset={0.47} stopColor="#fff" />
            <stop offset={1} stopColor="#A6A5B1" />
          </radialGradient>
          <radialGradient
            id="prefix__paint40_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(4.3239 0 0 4.32675 36.505 45.963)"
          >
            <stop offset={0.695} stopColor="#C3996B" />
            <stop offset={0.858} stopColor="#A87C4F" />
            <stop offset={1} stopColor="#4D3B2A" />
          </radialGradient>
          <radialGradient
            id="prefix__paint41_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(4.3239 0 0 4.32675 36.634 44.146)"
          >
            <stop offset={0.892} stopColor="#333233" stopOpacity={0} />
            <stop offset={1} stopColor="#333233" />
          </radialGradient>
          <radialGradient
            id="prefix__paint45_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.09667 0 0 7.10134 16.853 43.182)"
          >
            <stop offset={0.18} stopColor="#2E2B27" />
            <stop offset={0.605} stopColor="#322E2A" />
            <stop offset={0.99} stopColor="#3D3935" />
            <stop offset={1} stopColor="#3D3935" />
          </radialGradient>
          <radialGradient
            id="prefix__paint46_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.48126 0 0 7.48619 17.74 43.588)"
          >
            <stop offset={0.47} stopColor="#fff" />
            <stop offset={1} stopColor="#A6A5B1" />
          </radialGradient>
          <radialGradient
            id="prefix__paint47_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(3.94349 0 0 3.94609 18.676 45.715)"
          >
            <stop offset={0.695} stopColor="#C3996B" />
            <stop offset={0.858} stopColor="#A87C4F" />
            <stop offset={1} stopColor="#4D3B2A" />
          </radialGradient>
          <radialGradient
            id="prefix__paint48_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(3.94349 0 0 3.94609 18.794 44.057)"
          >
            <stop offset={0.892} stopColor="#333233" stopOpacity={0} />
            <stop offset={1} stopColor="#333233" />
          </radialGradient>
          <radialGradient
            id="prefix__paint50_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.13742 0 0 7.14212 15.932 28.803)"
          >
            <stop stopColor="#3D3935" />
            <stop offset={0.982} stopColor="#2E2B27" />
            <stop offset={1} stopColor="#2E2B27" />
          </radialGradient>
          <radialGradient
            id="prefix__paint51_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.19571 0 0 6.19979 36.457 28.015)"
          >
            <stop stopColor="#3D3935" />
            <stop offset={0.982} stopColor="#2E2B27" />
            <stop offset={1} stopColor="#2E2B27" />
          </radialGradient>
          <radialGradient
            id="prefix__paint52_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.55305 -.04057 .0406 1.55407 24.451 57.24)"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint53_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(.96052 0 0 .96115 31.137 54.186)"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint54_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(.96052 0 0 .96115 19.877 55.226)"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="prefix__paint55_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(11.7385 0 0 11.7462 30.213 79.357)"
          >
            <stop stopColor="#FFDC4B" />
            <stop offset={0.51} stopColor="#F7CD48" />
            <stop offset={1} stopColor="#EEBB45" />
          </radialGradient>
          <radialGradient
            id="prefix__paint62_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.66256 0 0 7.6676 23.577 78.423)"
          >
            <stop stopColor="#FFDC4B" />
            <stop offset={0.51} stopColor="#F7CD48" />
            <stop offset={1} stopColor="#EEBB45" />
          </radialGradient>
          <radialGradient
            id="prefix__paint64_radial"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.68198 0 0 1.68309 30.221 78.999)"
          >
            <stop offset={0.443} stopColor="#5675D3" />
            <stop offset={0.603} stopColor="#4E66CC" />
            <stop offset={0.908} stopColor="#3A40BB" />
            <stop offset={1} stopColor="#3333B5" />
          </radialGradient>
          <linearGradient
            id="prefix__paint1_linear"
            x1={19.746}
            y1={73.222}
            x2={24.899}
            y2={80.933}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DDC5AC" />
            <stop offset={1} stopColor="#DDC5AC" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint4_linear"
            x1={32.787}
            y1={73.992}
            x2={33.337}
            y2={91.519}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DDC5AC" />
            <stop offset={1} stopColor="#DDC5AC" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint9_linear"
            x1={35.669}
            y1={76.389}
            x2={35.821}
            y2={82.365}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DDC5AC" />
            <stop offset={1} stopColor="#DDC5AC" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint10_linear"
            x1={35.845}
            y1={78.167}
            x2={44.265}
            y2={79.916}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DDC5AC" />
            <stop offset={1} stopColor="#DDC5AC" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint21_linear"
            x1={14.45}
            y1={16.464}
            x2={68.136}
            y2={54.801}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9DADA3" />
            <stop offset={1} stopColor="#9DADA3" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint32_linear"
            x1={36.555}
            y1={11.986}
            x2={21.701}
            y2={66.871}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint42_linear"
            x1={35.977}
            y1={37.98}
            x2={35.977}
            y2={48.546}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A6A5B1" />
            <stop offset={1} stopColor="#A6A5B1" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint43_linear"
            x1={21.497}
            y1={53.389}
            x2={21.776}
            y2={50.165}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F29770" />
            <stop offset={0.256} stopColor="#F5A67E" />
            <stop offset={0.743} stopColor="#FBCCA2" />
            <stop offset={1} stopColor="#FFE3B7" />
          </linearGradient>
          <linearGradient
            id="prefix__paint44_linear"
            x1={20.733}
            y1={48.752}
            x2={22.434}
            y2={53.446}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F29770" />
            <stop offset={1} stopColor="#F29871" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint49_linear"
            x1={16.862}
            y1={37.21}
            x2={16.291}
            y2={46.841}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A6A5B1" />
            <stop offset={1} stopColor="#A6A5B1" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint56_linear"
            x1={31.256}
            y1={77.958}
            x2={33.287}
            y2={88.565}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DDC5AC" />
            <stop offset={1} stopColor="#DDC5AC" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint57_linear"
            x1={24.141}
            y1={80.052}
            x2={23.097}
            y2={76.223}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F29770" />
            <stop offset={0.256} stopColor="#F5A67E" />
            <stop offset={0.743} stopColor="#FBCCA2" />
            <stop offset={1} stopColor="#FFE3B7" />
          </linearGradient>
          <linearGradient
            id="prefix__paint58_linear"
            x1={22.171}
            y1={75.941}
            x2={20.8}
            y2={78.528}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint59_linear"
            x1={22.795}
            y1={74.416}
            x2={21.361}
            y2={77.372}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint60_linear"
            x1={23.372}
            y1={73.464}
            x2={21.887}
            y2={76.242}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint61_linear"
            x1={24.7}
            y1={72.694}
            x2={23.127}
            y2={75.18}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E8906B" />
            <stop offset={1} stopColor="#E8916C" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint63_linear"
            x1={24.864}
            y1={77.688}
            x2={25.27}
            y2={89.463}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DDC5AC" />
            <stop offset={1} stopColor="#DDC5AC" stopOpacity={0} />
          </linearGradient>
          <linearGradient
            id="prefix__paint65_linear"
            x1={33.051}
            y1={79.905}
            x2={32.255}
            y2={77.391}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F29770" />
            <stop offset={0.256} stopColor="#F5A67E" />
            <stop offset={0.743} stopColor="#FBCCA2" />
            <stop offset={1} stopColor="#FFE3B7" />
          </linearGradient>
          <clipPath id="prefix__clip0">
            <path fill="#fff" transform="translate(9.6)" d="M0 0h54.4v88H0z" />
          </clipPath>
        </defs>
      </svg>
    )
}

